module.exports = __webpack_public_path__ + "static/media/ButtonsVersions_06.6e52638a.png";